if (!customElements.get('wls-header')) {
    class WLSHeader extends HTMLElement {
        constructor() {
            super();

            this.BREAKPOINT = 1280;

            this.classes = {
                openClass: 'is-open',
                activeClass: 'is-active',
                removeClass: 'remove',
                headerMegamenuOpen: 'has-open-megamenu',
                bodyMegamenuOpen: 'has-open-megamenu',

                menuNavLinks: 'js-wls-block-header-nav-link',
                megamenu: 'js-wls-block-megamenu',

                hamburger: 'js-wls-header-menu-open',
                menuClose: 'js-wls-header-menu-close',
                mobileMenu: 'js-wls-header-mobile-menu',
            };

            this.elements = this.cacheElements();

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.initialize());
            } else {
                this.initialize();
            }
        }

        cacheElements() {
            return {
                menuNavLinks: this.querySelectorAll(`.${this.classes.menuNavLinks}`),
                hamburger: this.querySelector(`.${this.classes.hamburger}`),
                menuClose: this.querySelector(`.${this.classes.menuClose}`),
                mobileMenu: this.querySelector(`.${this.classes.mobileMenu}`),
                cartLink: this.querySelector('#cart-icon-bubble'),
            };
        }

        initialize() {
            if (this.elements.menuNavLinks.length) {
                this.bindDesktopNav();
                this.bindOutsideClick();
            }

            if (
                this.elements.hamburger &&
                this.elements.menuClose &&
                this.elements.mobileMenu
            ) {
                this.bindMobileMenu();
            }

            this.bindCartDrawer();
        }

        bindCartDrawer() {
            if (this.dataset.cartType !== 'drawer') return;

            const bind = () => {
                const cartLink = this.querySelector('#cart-icon-bubble');
                const cartDrawer = document.querySelector('cart-drawer');

                if (!cartLink || !cartDrawer || typeof cartDrawer.open !== 'function') {
                    return false;
                }

                if (cartLink.dataset.wlsCartDrawerBound === 'true') {
                    return true;
                }

                cartLink.dataset.wlsCartDrawerBound = 'true';
                cartLink.setAttribute('role', 'button');
                cartLink.setAttribute('aria-haspopup', 'dialog');

                cartLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    cartDrawer.open(cartLink);
                });

                return true;
            };

            const tryBind = (attemptsLeft = 30) => {
                if (bind()) return;

                if (attemptsLeft > 0) {
                    setTimeout(() => tryBind(attemptsLeft - 1), 50);
                }
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => tryBind(), { once: true });
            } else {
                tryBind();
            }

            if (typeof subscribe === 'function') {
                subscribe('cart-update', () => {
                    const cartLink = this.querySelector('#cart-icon-bubble');

                    if (cartLink) {
                        cartLink.dataset.wlsCartDrawerBound = 'false';
                        bind();
                    }
                });
            }
        }

        bindDesktopNav() {
            this.elements.menuNavLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const parent = link.closest('li') || link.parentElement;
                    const megamenu = parent.querySelector(`.${this.classes.megamenu}`);

                    if (!megamenu) return;

                    const isOpen = megamenu.classList.contains(this.classes.openClass);

                    this.closeAllMegamenus();

                    if (!isOpen) {
                        megamenu.classList.add(this.classes.openClass);
                        link.classList.add(this.classes.activeClass);
                    }

                    this.updateMegamenuOverlayState();
                });
            });
        }

        updateMegamenuOverlayState() {
            const hasOpenMegamenu = this.querySelector(
                `.${this.classes.megamenu}.${this.classes.openClass}`
            );
        
            this.classList.toggle(this.classes.headerMegamenuOpen, !!hasOpenMegamenu);
            document.body.classList.toggle(this.classes.bodyMegamenuOpen, !!hasOpenMegamenu);
        }

        closeAllMegamenus() {
            this.elements.menuNavLinks.forEach(link => {
                const parent = link.closest('li') || link.parentElement;
                const megamenu = parent.querySelector(`.${this.classes.megamenu}`);

                if (!megamenu) return;

                megamenu.classList.remove(this.classes.openClass);
                link.classList.remove(this.classes.activeClass);
            });

            this.updateMegamenuOverlayState();
        }

        bindOutsideClick() {
            document.addEventListener('click', (e) => {
                if (!this.contains(e.target)) {
                    this.closeAllMegamenus();
                }
            });
        }

        bindMobileMenu() {
            const { hamburger, menuClose, mobileMenu } = this.elements;

            hamburger.addEventListener('click', () => {
                mobileMenu.classList.add(this.classes.openClass);

                hamburger.classList.add(this.classes.removeClass);
                menuClose.classList.remove(this.classes.removeClass);

                document.body.style.overflow = 'hidden';
            });

            menuClose.addEventListener('click', () => {
                mobileMenu.classList.remove(this.classes.openClass);

                menuClose.classList.add(this.classes.removeClass);
                hamburger.classList.remove(this.classes.removeClass);

                document.body.style.overflow = '';
            });
        }
    }

    window.customElements.define('wls-header', WLSHeader);
}
